// Константы для Redux
export const SET_EMAIL = 'SET_EMAIL';
export const SET_TOKENS = 'SET_TOKENS';
export const SET_USER_PROFILE = 'SET_USER_PROFILE';